import cookie from 'js-cookie'
import { COOKIE_EXT } from '../constance'

let currentStore
/**
 * 从当前的cookie中设置对应的cookie，以免失效与后端不同步
 * 为什么可以这么做:
 *     1. 纯数据展示，没有登录验证会跳转到登录界面
 *     2. 用户名可以后端返回，也可以前端在登录的时候写入，但是与后端交互之后，session时间无法保证正确
 * @private
 */
function setCookie() {
    //在开发者环境中登录设置的cookie
    const devLoginCookie = [
        'paas_name',
        'user_id',
        'user_account_id',
        'paas_token',
        'user_account_id',
        'user_relation_role'
    ]
    devLoginCookie.forEach(key => {
        //cookie重新设置一次
        const value = cookie.get(key)
        if (value) {
            cookie.set(key, value, COOKIE_EXT)
        }
    })
}

/**
 * 界面离开的时候，视图一些需要处理的事情
 * private
 */
function beforeUnLoad() {
    setCookie()
}

export function resetCookie(store) {
    store = store || currentStore
    if (!store) return
    const { identity: result } = store.state
    const cookieToken = cookie.get('paas_token')
    if (
        cookieToken &&
        result &&
        result.paasToken &&
        result.paasToken !== cookieToken
    ) {
        cookie.set('paas_token', result.paasToken, { expires: 7 })
        cookie.set('user_id', result.userId, { expires: 7 })
        cookie.set('user_account_id', result.userAccountId, {
            expires: 7
        })
        cookie.set('user_relation_role', result.userRelationRole, {
            expires: 7
        })
    }
}

/**
 * 绑定事件
 */
export function bindNativeEvent() {
    window.addEventListener('beforeunload', beforeUnLoad)
}

/**
 * 解绑事件
 */
export function unBindNativeEvent() {
    window.removeEventListener('beforeunload', beforeUnLoad)
}

/**
 * 绑定事件
 */
export function bindPageShow(store) {
    currentStore = store
    window.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            resetCookie(currentStore)
        }
    })
}
